import { render } from "./FavoriteMatch.vue?vue&type=template&id=e5f106f0&ts=true"
import script from "./FavoriteMatch.vue?vue&type=script&lang=ts"
export * from "./FavoriteMatch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__